// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1PkfB","productName":"Table_productName__2kRzB"};